export var CheckKind;
(function (CheckKind) {
  CheckKind[CheckKind["Custom"] = 0] = "Custom";
  CheckKind[CheckKind["Aggregate"] = 1] = "Aggregate";
  CheckKind[CheckKind["BaseType"] = 2] = "BaseType";
  CheckKind[CheckKind["InstanceOf"] = 3] = "InstanceOf";
  CheckKind[CheckKind["Size"] = 4] = "Size";
  CheckKind[CheckKind["Float64"] = 5] = "Float64";
  CheckKind[CheckKind["LiteralType"] = 6] = "LiteralType";
  CheckKind[CheckKind["LiteralValue"] = 7] = "LiteralValue";
  CheckKind[CheckKind["LowerCase"] = 8] = "LowerCase";
  CheckKind[CheckKind["PropertyKey"] = 9] = "PropertyKey";
  CheckKind[CheckKind["PropertyKeyFormat"] = 10] = "PropertyKeyFormat";
  CheckKind[CheckKind["PropertyValue"] = 11] = "PropertyValue";
  CheckKind[CheckKind["Range"] = 12] = "Range";
  CheckKind[CheckKind["StringPattern"] = 13] = "StringPattern";
  CheckKind[CheckKind["UnionMatch"] = 14] = "UnionMatch";
  CheckKind[CheckKind["UnionTagPresent"] = 15] = "UnionTagPresent";
  CheckKind[CheckKind["UnionTagValue"] = 16] = "UnionTagValue";
  CheckKind[CheckKind["Trimmed"] = 17] = "Trimmed";
  CheckKind[CheckKind["UnicodeNormalization"] = 18] = "UnicodeNormalization";
  CheckKind[CheckKind["UnixTimestamp"] = 19] = "UnixTimestamp";
})(CheckKind || (CheckKind = {}));
